<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..."
  type="ball-scale-multiple"></ngx-spinner>
<app-header></app-header>
<section class="part_search_bar">
  <div class="row no-mar-lr no-pad-lr">
    <div class="offset-md-2 col-md-4 search_input">
      <div class="input-group">
        <input placeholder="{{'Search by Part Number' | translate}}" class="form-control" #inputstring [(ngModel)]="partSrchInput">
        <!-- <span class="input-group-addon">{{'PARTNO' | translate}}</span>
        <span class="input-group-addon search-button" (click)="searchParts(part)">
          <i class="fa fa-search"></i>
        </span> -->
      </div>
    </div>
    <div class=" col-md-3 mar-top-30" *ngIf="lineCodeList != undefined">
      <ng-multiselect-dropdown *ngIf="lineCodeList != undefined" [placeholder]="'Select Next Process'" [settings]="dropdownSettings"
        [data]="lineCodeList" [(ngModel)]="lineNoSrchInput" 
        (onSelect)="onItemSelect($event)" 
      (onDeSelect)="onDeSelect($event)">
      </ng-multiselect-dropdown>
    </div>

    <div class="col-md-2 mar-top-30">
      <button class="btn btn-dark" (click)="searchParts()"
      [disabled]="!partSrchInput && (!lineNoSrchInput || lineNoSrchInput.length === 0)">
        <i class="fa fa-search" aria-hidden="true"></i>&nbsp;&nbsp;Search</button>
    </div>
  </div>
</section>
<section class="part_search_bar">
  <div class="row no-mar-lr">
    <div class="col-md-12 search_input">
      <button class="btn btn-dark offset-md-9" (click)="exportSuppProcessCode()">
        <i class="fa fa-download" aria-hidden="true"></i>&nbsp;&nbsp;Export Supply Process Code</button>
    </div>
  </div>
</section>
<section class="package_container container" *ngIf="displayTables">
  <div class="row mar-top-50">
    <div class="col-md-12">
      <div class="row_title mar-btm-30">{{'Search_Result_New' | translate}}</div>
    </div>
    <div class="col-md-12">
      <p-table [value]="partList" [responsive]="true" [rows]="10" [paginator]="true"
        emptyMessage="{{'No Records Found' | translate}}" [pageLinks]="3" [rowsPerPageOptions]="[10,25,50,100]">
        <!-- <p-column styleClass="text-center" field="partNumber" header="{{'PARTNO' | translate}}"
          [sortable]="true"></p-column>
        <p-column styleClass="text-center" field="partName" header="{{'PARTNAME' | translate}}"
          [sortable]="true"></p-column>
        <p-column styleClass="text-center" field="lineNumber" header="{{'Next_Process' | translate}}"
          [sortable]="true"></p-column>
        <p-column styleClass="text-center" field="deliveryPoint" header="{{'Delivery_Point' | translate}}"
          [sortable]="true"></p-column>
        <p-column header="{{'ACTION' | translate}}">
          <ng-template let-row="rowData" pTemplate="body">
            <div class="text-center hasLink" (click)="addProcessCode(processCode,row)"
              pTooltip="Create New Supply Process Code" tooltipPosition="top">
              <i class="fa fa-plus-square-o fa-lg" aria-hidden="true"></i>
            </div>
          </ng-template>
        </p-column> -->
        <ng-template pTemplate="header">
          <tr>
              <th pSortableColumn="partNumber" style="width:20%">{{'PARTNO' | translate}} <p-sortIcon field="partNumber"></p-sortIcon></th>
              <th pSortableColumn="partName" style="width:20%">{{'PARTNAME' | translate}} <p-sortIcon field="partName"></p-sortIcon></th>
              <th pSortableColumn="lineNumber" style="width:20%">{{'Next_Process' | translate}}<p-sortIcon field="lineNumber"></p-sortIcon></th>
              <th pSortableColumn="deliveryPoint" style="width:20%">{{'Delivery_Point' | translate}} <p-sortIcon field="deliveryPoint"></p-sortIcon></th>
              <th style="width:20%">{{'ACTION' | translate}}</th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-value>
          <tr>
              <td>{{value.partNumber}}</td>
              <td>{{value.partName}}</td>
              <td>{{value.lineNumber}}</td>
              <td>{{value.deliveryPoint}}</td>
              <td> <div class="text-center hasLink" (click)="addProcessCode(processCode,row)"
                pTooltip="Create New Supply Process Code" tooltipPosition="top">
                <i class="fa fa-plus-square-o fa-lg" aria-hidden="true"></i>
              </div> </td>
          </tr>
      </ng-template>
      </p-table>
    </div>
  </div>
</section>

<section class="package_container container" *ngIf="displayTables">
  <div class="row mar-top-50 mar-btm-50">
    <div class="col-md-12 row">
      <div class="row_title col-md-6 mar-btm-30">{{'Search_Result_Edited' | translate}}</div>
      <div class="col-md-6" *ngIf="processCodedata != undefined && processCodedata.length > 0">
        <!-- <button class="btn btn-dark offset-md-1">
              <i class="fa fa-upload" aria-hidden="true"></i>&nbsp;&nbsp;Upload</button> -->
        <button class="btn btn-dark offset-md-9" (click)="exportCSV()">
          <i class="fa fa-download" aria-hidden="true"></i>&nbsp;&nbsp;Download</button>
      </div>
    </div>
    <div class="col-md-12">
      <p-table [value]="processCodedata" [responsive]="true" [rows]="10" [paginator]="true" [pageLinks]="3"
        emptyMessage="{{'No Records Found' | translate}}" [rowsPerPageOptions]="[10,25,50,100]">
        <!-- <p-column styleClass="text-center" field="partNumber" header="{{'PARTNO' | translate}}"
          [sortable]="true"></p-column>
        <p-column styleClass="text-center" field="partName" header="{{'PARTNAME' | translate}}"
          [sortable]="true"></p-column>
        <p-column styleClass="text-center" field="lineNumber" header="{{'Next_Process' | translate}}"
          [sortable]="true"></p-column>
        <p-column styleClass="text-center" field="partIdentifier" header="{{'Part_Identifier' | translate}}"
          [sortable]="true"></p-column>
        <p-column styleClass="text-center" field="deliveryPoint" header="{{'DELIVERYPOINT' | translate}}"
          [sortable]="true"></p-column>
        <p-column styleClass="text-center" field="location" header="{{'Supply_Process_Code' | translate}}"
          [sortable]="true"></p-column>
        <p-column styleClass="text-center" field="action" header="{{'ACTION' | translate}}">
          <ng-template let-row="rowData" pTemplate="body">
            <span class="hasLink mar-rgt-10" (click)="modifyProcessCode(processCode, row)" pTooltip="Modify"
              tooltipPosition="top">
              <i class="fa fa-pencil-square-o fa-lg" aria-hidden="true"></i>
            </span>
            <span class="mar-rgt-10">|</span>
            <span class="hasLink" (click)="copyProcessCode(processCode, row)" pTooltip="Copy" tooltipPosition="top">
              <i class="fa fa-files-o fa-lg" aria-hidden="true"></i>
            </span>
          </ng-template>
        </p-column> -->
        <ng-template pTemplate="header">
          <tr>
              <th pSortableColumn="partNumber" style="width:20%">{{'PARTNO' | translate}} <p-sortIcon field="partNumber"></p-sortIcon></th>
              <th pSortableColumn="partName" style="width:20%">{{'PARTNAME' | translate}} <p-sortIcon field="partName"></p-sortIcon></th>
              <th pSortableColumn="lineNumber" style="width:20%">{{'Next_Process' | translate}}<p-sortIcon field="lineNumber"></p-sortIcon></th>
              <th pSortableColumn="partIdentifier" style="width:20%">{{'Part_Identifier' | translate}} <p-sortIcon field="partIdentifier"></p-sortIcon></th>
              <th pSortableColumn="deliveryPoint" style="width:20%">{{'DELIVERYPOINT' | translate}} <p-sortIcon field="deliveryPoint"></p-sortIcon></th>
              <th pSortableColumn="location" style="width:20%">{{'Supply_Process_Code' | translate}} <p-sortIcon field="location"></p-sortIcon></th>
              <th style="width:20%">{{'ACTION' | translate}}</th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-value>
          <tr>
              <td>{{value.partNumber}}</td>
              <td>{{value.partName}}</td>
              <td>{{value.lineNumber}}</td>
              <td>{{value.partIdentifier}}</td>
              <td>{{value.deliveryPoint}}</td>
              <td>{{value.location}}</td>
              <td> <span class="hasLink mar-rgt-10" (click)="modifyProcessCode(processCode, row)" pTooltip="Modify"
                tooltipPosition="top">
                <i class="fa fa-pencil-square-o fa-lg" aria-hidden="true"></i>
              </span>
              <span class="mar-rgt-10">|</span>
              <span class="hasLink" (click)="copyProcessCode(processCode, row)" pTooltip="Copy" tooltipPosition="top">
                <i class="fa fa-files-o fa-lg" aria-hidden="true"></i>
              </span></td>
          </tr>
      </ng-template>

      </p-table>
    </div>
  </div>
</section>

<ng-template #processCode let-c="close" let-d="dismiss">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="processCodeForm" #f="ngForm" novalidate>
      <section class="no-mar-lr pad-btm-20 pad-lr-15">
        <div class="row pad-btm-20">
          <div class="row_title">{{'Supply_Process_Code' | translate }}</div>
        </div>
        <div class="row pad-btm-10">
          <div class="col-md-3">
            <div class="form-group row">
              <label class="col-sm-6 col-form-label">{{'CARDID' | translate}}
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="cardId">
                <errors [control]="processCodeForm.controls.cardId"></errors>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group row">
              <label class="col-sm-6 col-form-label">{{'TRANSCODE' | translate}}
                <span class="required">*</span>
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="transactionCode">
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group row">
              <label class="col-sm-6 col-form-label">{{'PARTNUMBER' | translate}}
                <span class="required">*</span>
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="partNumber">
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group row">
              <label class="col-sm-4.5 col-form-label">{{'PARTNAME' | translate}}
                <span class="required">*</span>
              </label>
              <div class="col-sm-8">
                <input class="form-control" formControlName="partName">
              </div>
            </div>
          </div>
        </div>
        <div class="row pad-btm-30">
          <div class="col-md-3">
            <div class="form-group row">
              <label class="col-sm-6 col-form-label">{{'Next_Process' | translate}}
                <span class="required">*</span>
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="lineNumber">
              </div>
            </div>
          </div>
          <!--  -->
          <div class="col-md-3">
            <div class="form-group row"
              [ngClass]="{'has-error': processCodeForm.get('deliveryPlant').invalid && f.submitted}">
              <label class="col-sm-7 col-form-label">{{'Delivery_Plant_Code_Form' | translate}}
                <span class="required">*</span>
              </label>
              <div class="col-sm-5">
                <select class="form-control" formControlName="deliveryPlant" #plantValue
                  (ngModelChange)="prodGroupValue(plantValue.value)">
                  <option value="">{{'Select' | translate}}</option>
                  <option *ngFor="let type of delPlantOpt" name="type" [value]="type">{{type}}</option>
                </select>
                <div *ngIf="processCodeForm.get('deliveryPlant').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <errors [control]="processCodeForm.controls.deliveryPlant"></errors>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group row"
              [ngClass]="{'has-error': processCodeForm.get('productionGrp').invalid && f.submitted}">
              <label class="col-sm-6 col-form-label">{{'PRODGRP' | translate}}
                <span class="required">*</span>
              </label>
              <div class="col-sm-6">
                <select class="form-control" formControlName="productionGrp">
                  <option value="">{{'Select' | translate}}</option>
                  <option *ngFor="let type of prodOpt" name="type" [value]="type">{{type}}</option>
                </select>
                <div *ngIf="processCodeForm.get('productionGrp').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <errors [control]="processCodeForm.controls.productionGrp"></errors>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group row"
              [ngClass]="{'has-error': processCodeForm.get('storeQty').invalid && f.submitted}">
              <label class="col-sm-5.5 col-form-label">{{'STOREQTY' | translate}}
              </label>
              <div class="col-sm-7">
                <input class="form-control" formControlName="storeQty">
                <errors [control]="processCodeForm.controls.storeQty"></errors>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group row"
              [ngClass]="{'has-error': processCodeForm.get('partIdetifier').invalid && f.submitted}">
              <label class="col-sm-6 col-form-label">{{'PARTIDENTIFIER' | translate}}
                <span class="required">*</span>
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="partIdetifier" #identifier
                  (keypress)="omit_special_char($event)" maxlength="1" (ngModelChange)="valuechange(identifier.value)"
                  [value]="identifier.value.toUpperCase()">
                <div *ngIf="processCodeForm.get('partIdetifier').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <div id="mytext" class="required-error"></div>
                <!-- <div *ngIf="processCodeForm.get('partIdetifier').errors?.pattern" class="required-error">Invalid Pattern</div> -->
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group row"
              [ngClass]="{'has-error': processCodeForm.get('lotSeperate').invalid && f.submitted}">
              <label class="col-sm-6 col-form-label">{{'LOTSEPERATE' | translate}}
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="lotSeperate">
                <errors [control]="processCodeForm.controls.lotSeperate"></errors>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group row">
              <label class="col-sm-6 col-form-label">{{'UPDATEDATE' | translate}}
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="updateDate">
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="pad-top-10 no-mar-lr pad-btm-20 pad-lr-15">
        <div class="row pad-btm-10">
          <div class="col-md-2">
            <div class="row_title pad-btm-10">{{'Location' | translate}}</div>
          </div>
        </div>
        <div class="row pad-btm-20">
          <div class="col-md-3">
            <div class="form-group row"
              [ngClass]="{'has-error': processCodeForm.get('buildingNumber').invalid && f.submitted}">
              <label class="col-sm-6 col-form-label">{{'Building_Number'| translate}}
                <span class="required">*</span>
              </label>
              <div class="col-sm-6">
                <select class="form-control" formControlName="buildingNumber">
                  <option value="">{{'Select' | translate}}</option>
                  <option *ngFor="let opt of buildingNumberOpt" [value]="opt.value">{{opt.name}}</option>
                </select>
                <errors [control]="processCodeForm.controls.buildingNumber"></errors>
                <div *ngIf="processCodeForm.get('buildingNumber').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="sub_title pad-btm-10">{{'Supply_Process_Code' | translate}}:</div>
        <div class="row">
          <div class="col-md-2">
            <div class="form-group row"
              [ngClass]="{'has-error': processCodeForm.get('productCode').invalid && f.submitted}">
              <div class="col-sm-10">
                <input class="form-control" formControlName="productCode" [pattern]="productCodepattern" maxlength="1">
                <div *ngIf="processCodeForm.get('productCode').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <div *ngIf="processCodeForm.get('productCode').errors?.pattern" class="required-error">Product Code
                  should be a digit or an Uppercase alphabet</div>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group row" [ngClass]="{'has-error': processCodeForm.get('group').invalid && f.submitted}">
              <div class="col-sm-10">
                <input class="form-control" formControlName="group" [pattern]="levelPattern" maxlength="1">
                <div *ngIf="processCodeForm.get('group').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <div *ngIf="processCodeForm.get('group').errors?.pattern" class="required-error">Group should be a
                  digit or alphabet</div>
              </div>
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group row"
              [ngClass]="{'has-error': processCodeForm.get('processCde').invalid && f.submitted}">
              <div class="col-sm-10">
                <input class="form-control" formControlName="processCde" [pattern]="processCodePattern" maxlength="1">
                <div *ngIf="processCodeForm.get('processCde').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <div *ngIf="processCodeForm.get('processCde').errors?.pattern" class="required-error">Process Code
                  should contain 1 alphanumeric value</div>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group row"
              [ngClass]="{'has-error': processCodeForm.get('processNo').invalid && f.submitted}">
              <div class="col-sm-10">
                <input class="form-control" formControlName="processNo" [pattern]="processNamePattern" maxlength="2">
                <div *ngIf="processCodeForm.get('processNo').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <div *ngIf="processCodeForm.get('processNo').errors?.pattern" class="required-error">Process Number
                  should contain 2 alphanumeric value</div>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group row"
              [ngClass]="{'has-error': processCodeForm.get('rackNumber').invalid && f.submitted}">
              <div class="col-sm-10">
                <input class="form-control" formControlName="rackNumber" [pattern]="rackPattern" maxlength="2">
                <div *ngIf="processCodeForm.get('rackNumber').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <div *ngIf="processCodeForm.get('rackNumber').errors?.pattern" class="required-error">Rack Number
                  should be of 2 digit or alphabet</div>
              </div>
            </div>
          </div>
          <div class="col-md-1">
            <div class="form-group row" [ngClass]="{'has-error': processCodeForm.get('level').invalid && f.submitted}">
              <div class="col-sm-10">
                <input class="form-control" formControlName="level" [pattern]="levelPattern" maxlength="1">
                <div *ngIf="processCodeForm.get('level').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <div *ngIf="processCodeForm.get('level').errors?.pattern" class="required-error">Level should be of 1
                  digit or alphabet</div>
              </div>
            </div>
          </div>
          <div class="col-md-1">
            <div class="form-group row" [ngClass]="{'has-error': processCodeForm.get('column').invalid && f.submitted}">
              <div class="col-sm-10">
                <input class="form-control" formControlName="column" [pattern]="columnPattern" maxlength="1">
                <div *ngIf="processCodeForm.get('column').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <div *ngIf="processCodeForm.get('column').errors?.pattern" class="required-error">Column should be one
                  digit between 1 and 9</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row pad-btm-20">
          <div class="col-md-2">
            <label class="col-form-label pad-lft-20">{{'product_Code' | translate}}
              <span class="required">*</span>
            </label>
          </div>
          <div class="col-md-2">
            <label class="col-form-label pad-lft-40">{{'Group' | translate }}
              <span class="required">*</span>
            </label>
          </div>
          <div class="col-md-2">
            <label class="col-form-label pad-lft-20">{{'Process_Code' | translate}}
              <span class="required">*</span>
            </label>
          </div>
          <div class="col-md-2">
            <label class="col-form-label pad-lft-20">{{'Process_Number' | translate }}
              <span class="required">*</span>
            </label>
          </div>
          <div class="col-md-2">
            <label class="col-form-label pad-lft-40">{{'Rack_Number' | translate }}
              <span class="required">*</span>
            </label>
          </div>
          <div class="col-md-1">
            <label class="col-form-label pad-lft-20">{{'level' | translate}}
              <span class="required">*</span>
            </label>
          </div>
          <div class="col-md-1">
            <label class="col-form-label pad-lft-20">{{'Column' | translate}}
              <!-- <span class="required">*</span> -->
            </label>
          </div>
        </div>
        <div class="sub_title pad-btm-10">{{'Replenishment improvement' | translate}}</div>
        <div class="row pad-btm-20">
          <div class="col-md-3">
            <div class="form-group row"
              [ngClass]="{'has-error': processCodeForm.get('shelfCapacity').invalid && f.submitted}">
              <label class="col-sm-6 col-form-label">{{'Shelf capacity' | translate}}
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="shelfCapacity" [pattern]="shelfCapPattern"
                  [(ngModel)]="shelfCap" maxlength="50" (change)="checkValue()">
                <!-- <errors [control]="processCodeForm.controls.shelfCapacity"></errors> -->
                <!-- <div *ngIf="processCodeForm.get('shelfCapacity').invalid && f.submitted" class="required-error">{{'FieldRequired'
                  | translate}}</div> -->
                <div *ngIf="processCodeForm.get('shelfCapacity').errors?.pattern" class="required-error">Shelf Capacity
                  should be an integer which is 1 or bigger</div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group row"
              [ngClass]="{'has-error': processCodeForm.get('replenishmentThreshold').invalid && f.submitted}">
              <label class="col-sm-6 col-form-label">{{'Replenishment Threshold' | translate}}
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="replenishmentThreshold" [(ngModel)]="ReplenThresh"
                  [pattern]="thresholdPattern" (change)="checkValue()">
                <!-- <errors [control]="processCodeForm.controls.replenishmentThreshold"></errors> -->
                <!-- <div *ngIf="processCodeForm.get('replenishmentThreshold').invalid && f.submitted" class="required-error">{{'FieldRequired'
                  | translate}}</div> -->
                <div *ngIf="processCodeForm.get('replenishmentThreshold').errors?.pattern" class="required-error">
                  Replenishment
                  Threshold should be a positive integer or 0</div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group row">
              <label class="col-sm-7 col-form-label">{{'TRANSPORTATION_MODE' | translate}}
              </label>
              <div class="col-sm-5">
                <select class="form-control" formControlName="transportationMode">
                  <option value="">{{'Select' | translate}}</option>
                  <option *ngFor="let item of transModeOpt" name="item" [value]="item">{{item | translate }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group row">
              <label class="col-sm-7 col-form-label">{{'TRIGGER' | translate}}
              </label>
              <div class="col-sm-5">
                <select class="form-control" formControlName="trigger" (change)="triggerChange($event)">
                  <option value="">{{'Select' | translate}}</option>
                  <option *ngFor="let item of triggerOpt" name="item" [value]="item">{{item}}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group row"
              [ngClass]="{'has-error': processCodeForm.get('boxperpallet').invalid && f.submitted}">
              <label class="col-sm-6 col-form-label">{{'Boxes_Per_Pallet' | translate}}
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="boxperpallet" [pattern]="shelfCapPattern"
                  [(ngModel)]="boxPerPal" maxlength="50" (change)="checkValue()">
                <!-- <errors [control]="processCodeForm.controls.shelfCapacity"></errors> -->
                <!-- <div *ngIf="processCodeForm.get('shelfCapacity').invalid && f.submitted" class="required-error">{{'FieldRequired'
                  | translate}}</div> -->
                <div *ngIf="processCodeForm.get('boxperpallet').errors?.pattern" class="required-error">Boxes per Pallet
                  should be an integer which is 1 or bigger</div>
              </div>
            </div>
          </div>


          <!-- ******************************************************************************************* -->
          <div *ngIf="showTiming" class="col-md-3">
            <div class="form-group row" [ngClass]="{'has-error': f.submitted}">
              <label class="col-sm-6 col-form-label">{{'Seconds' | translate}} <span class="required">*</span>
              </label>

              <div class="col-sm-6">
                <input class="form-control" formControlName="seconds" [(ngModel)]="secondsValue">
                <label>0-59</label>
                <errors [control]="processCodeForm.controls.seconds"></errors>
                <div *ngIf="processCodeForm.get('seconds').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <!-- <div *ngIf="processCodeForm.get('weekDay').errors?.pattern" class="required-error">No alphabets allowed</div> -->
              </div>
            </div>
          </div>

          <div *ngIf="showTiming" class="col-md-3">
            <div class="form-group row" [ngClass]="{'has-error': f.submitted}">
              <label class="col-sm-6 col-form-label">{{'Minutes' | translate}} <span class="required">*</span>
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="minute" [(ngModel)]="minuteValue"> <label>0-59</label>
                <!-- <errors [control]="processCodeForm.controls.shelfCapacity"></errors> -->
                <div *ngIf="processCodeForm.get('minute').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <!-- <div *ngIf="processCodeForm.get('weekDay').errors?.pattern" class="required-error">No alphabets allowed</div> -->
              </div>
            </div>
          </div>

          <div *ngIf="showTiming" class="col-md-3">
            <div class="form-group row" [ngClass]="{'has-error': f.submitted}">

              <label class="col-sm-6 col-form-label">{{'Hour' | translate}} <span class="required">*</span>
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="hour" [(ngModel)]="hourValue"> <label>0-23</label>
                <!-- <errors [control]="processCodeForm.controls.shelfCapacity"></errors> -->
                <div *ngIf="processCodeForm.get('hour').invalid && f.submitted" class="required-error">{{'FieldRequired'
                  | translate}}</div>
                <!-- <div *ngIf="processCodeForm.get('weekDay').errors?.pattern" class="required-error">No alphabets allowed</div> -->
              </div>
            </div>
          </div>

          <div *ngIf="showTiming" class="col-md-3">
            <div class="form-group row" [ngClass]="{'has-error': f.submitted}">
              <label class="col-sm-6 col-form-label">{{'Day of Month' | translate}} <span class="required">*</span>
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="dayOfMonth" [(ngModel)]="dayOfMonthValue">
                <label>1-31</label>
                <!-- <errors [control]="processCodeForm.controls.shelfCapacity"></errors> -->
                <div *ngIf="processCodeForm.get('dayOfMonth').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <!-- <div *ngIf="processCodeForm.get('weekDay').errors?.pattern" class="required-error">No alphabets allowed</div> -->
              </div>
            </div>
          </div>

          <div *ngIf="showTiming" class="col-md-3">
            <div class="form-group row" [ngClass]="{'has-error': f.submitted}">
              <label class="col-sm-6 col-form-label">{{'Month of Year' | translate}} <span class="required">*</span>
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="monthOfYear" [(ngModel)]="monthOfYearValue">
                <label>1-12</label>
                <!-- <errors [control]="processCodeForm.controls.shelfCapacity"></errors> -->
                <div *ngIf="processCodeForm.get('monthOfYear').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <!-- <div *ngIf="processCodeForm.get('weekDay').errors?.pattern" class="required-error">No alphabets allowed</div> -->
              </div>
            </div>
          </div>

          <div *ngIf="showTiming" class="col-md-3">
            <div class="form-group row" [ngClass]="{'has-error': f.submitted}">
              <label class="col-sm-6 col-form-label">{{'Day of Week' | translate}} <span class="required">*</span>
              </label>
              <div class="col-sm-6">
                <input class="form-control" formControlName="dayOfWeek" [(ngModel)]="dayOfWeekValue">
                <label>0-6</label>
                <!-- <errors [control]="processCodeForm.controls.shelfCapacity"></errors> -->
                <div *ngIf="processCodeForm.get('dayOfWeek').invalid && f.submitted" class="required-error">
                  {{'FieldRequired'
                  | translate}}</div>
                <!-- <div *ngIf="processCodeForm.get('weekDay').errors?.pattern" class="required-error">No alphabets allowed</div> -->
              </div>
            </div>
          </div>

          <div *ngIf="showTiming" class="col-md-12">
            <p>{{'Notes' | translate}} : </p>
            <ul>
              <li>{{'Enter * symbol if it is required for all year/ month/ week/ day/ hour/ minutes' | translate}}</li>
              <li>{{'Please refer to below guide to fill the CRON expression' | translate}}</li>
            </ul>

            <table class="text-center" class="table table-white table-bordered table-striped">
              <thead>
                <tr>
                  <th class="text-center" *ngFor="let name of cronExpressionListHead">{{name | translate}}</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let name of cronExpressionListInfo">
                  <td class="text-center">{{name.name | translate}}</td>
                  <td class="text-center">{{name.mandatory}}</td>
                  <td class="text-center">{{name.allowedValue }}</td>
                  <td class="text-center"><span>&#42;</span><span>&#44;</span><span>&#45;</span></td>
                  <td class="text-center">{{name.remarks | translate}}</td>
                </tr>
              </tbody>

            </table>


            <ul>
              <li>{{'Sample pattern' | translate}}:</li>
            </ul>
            <table style="margin-left: 24px">
              <tbody>
                <tr>
                  <td style="width:400px">{{'Pattern for every 4 minutes' | translate}}</td>
                  <td>* */4 * * * *</td>
                </tr>

                <tr>
                  <td style="width:400px">{{'Pattern for every day 11:30 PM' | translate}}</td>
                  <td>0 30 23 * * *</td>
                </tr>

                <tr>
                  <td style="width:400px">{{'Pattern for Monday to Friday day 11:30PM' | translate}}</td>
                  <td>0 30 23 * * 1-5</td>
                </tr>

                <tr>
                  <td style="width:400px">{{'Pattern for every alternative days of week @8:00 PM' | translate}}</td>
                  <td>0 0 20 * * 1,3,5</td>
                </tr>

                <tr>
                  <td style="width:400px">{{'Pattern for every 15th day of month @ 8:00 PM' | translate}}</td>
                  <td>0 0 20 15 * *</td>
                </tr>

              </tbody>
            </table>

          </div>

          <!-- ************************************************************************************************ -->
        </div>
        <div *ngIf="thresholdGreater == true" class="error">{{'Replenishment Threshold should be less than Shelf Capacity' | translate}}</div>
      </section>

      <section class="package_container container" *ngIf="showLocationHistory == true">
        <div class="row_title mar-top-20">Location History</div>
        <div class="row mar-top-50">
          <div class="col-md-12">
            <p-table [value]="historyListData" [responsive]="true" [rows]="5" [paginator]="true">
              <!-- <p-column field="buildingNo" header="Building Number"></p-column>
              <p-column field="productCode" header="Product Code"></p-column>
              <p-column field="group" header="Group"></p-column>
              <p-column field="processValCode" header="Process Code"></p-column>
              <p-column field="processValName" header="Process No"></p-column>
              <p-column field="rackNo" header="Rack Number"></p-column>
              <p-column field="level" header="Level"></p-column>
              <p-column field="fromDate" header="Valid From"></p-column>
              <p-column field="updatedBy" header="Updated By"></p-column> -->
              <ng-template pTemplate="header">
                <tr>
                    <th>{{'Building Number' | translate}}</th>
                    <th >{{'Product Code' | translate}}</th>
                    <th >{{'Group' | translate}}</th>
                    <th >{{'Process Code' | translate}} </th>
                    <th >{{'Process No' | translate}} </th>
                    <th>{{'Rack Number' | translate}}</th>
                    <th>{{'Level' | translate}}</th>
                    <th>{{'Valid From' | translate}}</th>
                    <th>{{'Updated By' | translate}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-value>
                <tr>
                    <td>{{value.buildingNo}}</td>
                    <td>{{value.productCode}}</td>
                    <td>{{value.group}}</td>
                    <td>{{value.processValCode}}</td>
                    <td>{{value.processValName}}</td>
                    <td>{{value.rackNo}}</td>
                    <td>{{value.level}}</td>
                    <td>{{value.fromDate}}</td>
                    <td>{{value.updatedBy}}</td>
                </tr>
            </ng-template>
            </p-table>
          </div>
        </div>
      </section>
      <div class="row">
        <div class="offset-md-4 mar-top-30">
          <button type="submit" class="btn btn-dark mar-rgt-60" (click)="submitProcessCode(f)"
            [disabled]="saveButton == false">{{'SAVE'
            | translate}}</button>
          <button type="button" class="btn btn-dark-brd" (click)="closeModal()">{{'CANCEL' | translate}}</button>
        </div>
      </div>
    </form>

  </div>
  <div class="modal-footer">

  </div>
</ng-template>